<template>
  <div>
    <template v-if="categories && categories.length">
      <div class="faq__categories">
        <div v-for="(category, index) in categories"
             :key="category.id || index"
             class="faq__category"
             @click="setActiveTab(index)">
          {{ category.name }}
        </div>
      </div>
      <h2 class="faq__subHeading">
        {{ activeCategory.name }} FAQs
      </h2>
      <div class="faq__categorySection">
        <ul class="faq__questions">
          <li v-for="(q, index) in activeCategory.questions"
              :key="index"
              :class="['faq__question', { 'faq__question--active': activeQuestionIndex === index }]"
              @click="setActiveQuestion(index)">
            <span>{{ q.question }}</span>
            <font-awesome-icon class="ml-2"
                               icon="chevron-right">
            </font-awesome-icon>
          </li>
        </ul>
        <div ref="active-question-answer"
             class="faq__answer">
             <!-- content managed result comes from Umbraco RTE -->
        </div>
      </div>
    </template>
    <template v-else>
      <p>Please add some categories within your Umbraco CMS</p>
    </template>
  </div>
</template>
<script>
export default {
  name: "Faqs",
  props: {
    categories: {
      type: Array,
      validator: val => {
        const keys = ["id", "name", "questions"];
        const questionKeys = ["question", "supportingInformation"];
        let validArr = false;
        if ( val && val.length ) {
          validArr = val.every( obj => {
            let valid = keys.every( key => key in obj );

            if ( valid ) {
              const { questions } = obj;
              valid = questions.every( q => questionKeys.every( key => key in q ) );
            }
            return valid;
          } );
        }

        return validArr;
      },
      required: true,
    },
  },
  data: () => ( {
    activeTab: undefined,
    activeQuestionIndex: undefined,
  } ),
  computed: {
    activeCategory () {
      return this.categories[this.activeTab] || { name: undefined, questions: undefined };
    },
    activeQuestion () {
      return this.activeCategory && this.activeCategory.questions
        ? this.activeCategory.questions[this.activeQuestionIndex]
        : undefined;
    },
  },
  watch: {
    activeCategory: {
      handler ( val, oldVal ) {
        if ( val.id !== oldVal.id ) {
          this.setActiveQuestion( 0 );
        }
      },
    },
    activeQuestion: {
      handler ( val ) {
        const { supportingInformation } = val;
        const answerEl = this.$refs["active-question-answer"];

        if ( answerEl ) {
          const transition = "faq__answer--ease-in";
          answerEl.classList.remove( transition );
          answerEl.innerHTML = supportingInformation;
          // assits with triggering animation
          setTimeout( () => {
            answerEl.classList.add( transition );
          }, 10 );
        }
      },
    },
  },
  mounted () {
    window.addEventListener( "hashchange", this.updateTabFromHash );
    this.updateTabFromHash();
  },
  beforeDestroy () {
    window.removeEventListener( "hashchange", this.updateTabFromHash );
  },
  methods: {
    updateTabFromHash () {
      const hash = window.location.hash.replace( "#", "" );

      if ( hash && hash.length > 0 && this.categories && this.categories.length > 0 ) {
        const matchingIndex = this.categories.findIndex( c => c.name && c.name.length
        && this.slugify( c.name ) === hash );

        if ( matchingIndex !== this.activeTab ) {
          this.setActiveTab( matchingIndex );
        }
      }
    },
    setActiveTab ( index ) {
      this.activeTab = index;
      window.location.hash = this.slugify( this.activeCategory.name );
    },
    setActiveQuestion ( index ) {
      this.activeQuestionIndex = index;
    },
    slugify ( text ) {
      return text
        .toString() // Cast to string (optional)
        .normalize( "NFKD" ) // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
        .toLowerCase() // Convert the string to lowercase letters
        .trim() // Remove whitespace from both sides of a string (optional)
        .replace( /\s+/g, "-" ) // Replace spaces with -
        .replace( /[^\w-]+/g, "" ) // Remove all non-word chars
        .replace( /--+/g, "-" ); // Replace multiple - with single -
    },
  },
};
</script>
<style lang="less" scoped>
  @import "../../Styles/utils/index.less";

  .faq {
    &__categories

  {
    display: flex;
    flex-wrap: wrap;
    margin: 46px -16px;

    @media (max-width: @tablet) {
      justify-content: center;
    }
  }

  &__subHeading {
    margin: 0 0 28px;
    font-weight: 300;
  }

  &__category {
    min-width: 200px;
    width: 238px;
    height: 40px;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    background-color: @color-accent-5;
    color: #fff;
    cursor: pointer;
    margin: 0 16px 16px;
    .border-radius(5px);
    &:hover

  {
    background-color: @color-accent-2;
  }

  @media (max-width: @tablet) {
    width: 100%;
  }

  }

  &__categorySection {
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 60px;

    @media (max-width: @phone) {
      margin: 0 0 30px;
    }

    > ul

  {
    list-style-type: none;
    padding: 0;
    .gap(40px);
    > li

  {
    display: flex;
    align-items: center;
    color: @color-accent-1-dark;
    font-size: 16px;
    line-height: 18px;
    font-weight: 500;
    max-width: 285px;
    border-bottom: 1px solid @color-accent-5;
    padding: 0 0 8px;
    margin: 0 0 8px;
    cursor: pointer;
  }

  }
  }

  &__question {
    &--active

  {
    color: @color-accent-2-dark !important;
  }

  }

  &__answer {
    flex: 1;
    min-width: 200px;
    opacity: 0;
    &--ease-in

  {
    opacity: 1;
    .transition(opacity 0.3s ease-in);
  }

  }
  }
</style>
